<template>
  <!-- master 根據 sidebarCollapsed 狀態切換 class -->
  <div class="master" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
    <!-- ===== NEW !!! TOP NAV ===== -->
    <!-- Sidebar width is reserved via top-nav-inner padding-left (CSS var) -->
    <div class="fixed-top top-nav">
      <b-navbar toggleable="sm" type="dark" variant="gray-950" class="w-100 top-nav-inner px-3">

        <!-- Logo + System Name Block -->
        <div class="top-nav-brand">
          <img src="../../static/image/logo_Getac.svg" class="top-nav-logo" alt="Getac Logo" />
          <div class="top-nav-title-block">
            <span class="top-nav-system-name">ETO NRE System</span>
            <span class="top-nav-version">Ver {{ $session.get('version') }}</span>
          </div>
        </div>

        <!-- Environment Badge (非正式區才顯示) -->
        <div v-if="!prdEnv()" class="top-nav-env-badge" :class="envBadgeClass">
          <i class="fa" :class="envIcon"></i>
          <span class="env-label">{{ $session.get('mode') }}</span>
          <span class="env-sublabel">{{ currentRouteName }}</span>
        </div>

        <b-navbar-nav class="ml-auto align-items-center top-nav-user-nav">
          <b-nav-item-dropdown class="ml-auto align-items-center" right>
            <template #button-content>
              <img src="../../static/image/icon_user.svg" style="height: 3.28rem" alt="User Icon" />
              <b-nav-text class="text-white mr-3 user-name">{{ $session.get('user_name') }}</b-nav-text>
            </template>
            <b-dropdown-item to="/ftie/to-do-list">To Do List</b-dropdown-item>
            <b-dropdown-item v-if="user_site && _.indexOf(user_site, 'Getac') > -1"
                             href="https://ftie.getac.com.tw/ftie/new_request_list_hq.aspx"
                             target="_blank">Getac Report</b-dropdown-item>
            <b-dropdown-item v-if="user_site && _.indexOf(user_site, 'Getac') <= -1"
                             href="https://ftie.getac.com.tw/ftie/new_request_list1.aspx"
                             target="_blank">GRO Report</b-dropdown-item>
            <b-dropdown-item v-if="user_site && _.indexOf(user_site, 'Getac') > -1"
                             href="https://ftie.getac.com.tw/ftie/new_display_sector_data.aspx"
                             target="_blank">Tree View Report</b-dropdown-item>
            <b-dropdown-item href="#" @click="signout">Log Out</b-dropdown-item>
            <b-dropdown-item v-if="!prdEnv()" href="#" @click="linkAzureDevOps">
              * Link AzureDevOps
            </b-dropdown-item>
            <b-dropdown-item v-if="!prdEnv() && adminMemberSettingAccess()" to="/gen-ai">
              * GenAI Module
            </b-dropdown-item>
            <b-dropdown-item v-if="adminMemberSettingAccess() || salesforceReportAccess()"
                             @click="outlineSalesforceReportList">
              * Salesforce Reports
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-navbar>

      <!-- Azure DevOps Modal -->
      <b-modal hide-footer centered size="lg" ref="linkAzureDevOpsModal"
               title="BOD Azure DevOps Projects" button-size="sm">
        <div style="padding-top: 10px;" v-if="azureDevOpsPrjs !== null">
          <b-table :fields="azureDevOpsPrjsFields" :items="azureDevOpsPrjs"
                   small thead-cl * *
                   ass="thead-light text-dark" :busy="searchingADOPrj"
                   style="width: calc(100% - 10px)">
            <template #cell(action)="data">
              <button v-if="adminMemberSettingAccess() && data.item.project_id !== null"
                      type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-edit"
                      v-b-tooltip.hover.right title="Create WorkItems"
                      @click="createWorkItem(data.item.project_id, data.item.project_name)">
              </button>
            </template>
          </b-table>
        </div>
      </b-modal>

      <!-- Salesforce Modal -->
      <b-modal hide-footer centered size="lg" ref="salesforceReportModal"
               title="Available Report in Salesforce" button-size="sm">
        <div style="padding-top: 10px;"
             v-if="salesforceReportAccess() && salesforceReportList !== null">
          <b-table :fields="sfdcReportFields" :items="salesforceReportList"
                   small thead-class="thead-light text-dark" :busy="searchingSFDC"
                   style="width: calc(100% - 10px)">
            <template #cell(Name)="data">
              <button v-if="(adminMemberSettingAccess() || salesforceReportAccess()) && data.item.Id !== null && ifReportOpenDownload(data.item.Id)"
                      type="button"
                      class="btn btn-sm btn-link p-0 btn-svg gtc-icon-download"
                      v-b-tooltip.hover.right title="Download Report"
                      @click="downloadSalesforceReport(data.item.Id, data.item.Name)">
              </button>
              <a class="link" target="_blank"
                 :href="safeUrl($root.frontEndUrl + '/salesforce/report/report-id/' + data.item.Id)">
                {{ data.item.Name }}
              </a>
            </template>
            <template #cell(Id)="data">
              <a class="link" target="_blank"
                 :href="safeUrl($root.frontEndUrl + '/salesforce/report/report-id/' + data.item.Id)">
                {{ data.item.Id }}
              </a>
            </template>
          </b-table>
        </div>
      </b-modal>

    </div>
    <!-- ===== END NEW !!! TOP NAV ===== -->
    <!-- ===== LAYOUT BODY ===== -->
    <div class="layout-body">

      <!-- ===== SIDEBAR ===== -->
      <div class="side-nav bg-gray-950" :class="{ 'side-nav-collapsed': sidebarCollapsed }">

        <!-- Hamburger toggle — top of sidebar, same column as menu items -->
        <button class="btn side-nav-toggle-btn border-radius-0 w-100"
                @click="toggleSidebar">
          <span class="side-nav-icon">
            <img src="../../static/image/icon_menu.svg" alt="Menu Icon" />
          </span>
          <span class="side-nav-label">Menu</span>
        </button>

        <!-- Nav items -->
        <nav class="side-nav-items">

          <!-- HOME -->
          <button class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'home' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('home')"
                  v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Home' : ''">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_HOME.svg" alt="Home" />
            </span>
            <span class="side-nav-label">Home</span>
          </button>

          <!-- OPPORTUNITY -->
          <button v-if="optyDashboardAccess()"
                  class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'opty' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('opportunity/dashboard')"
                  v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Opportunity' : ''">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_OPTY.svg" alt="Opportunity" />
            </span>
            <span class="side-nav-label">Opportunity</span>
          </button>

          <!-- TASK  v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Task' : ''"-->
          <button v-if="taskDashboardAccess()"
                  class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'task' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('task/dashboard')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_TASK.svg" alt="Task" />
            </span>
            <span class="side-nav-label">Task</span>
          </button>

          <!-- ENGINEERING SERVICES v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Engineering Services' : ''"-->
          <button class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'engineering-service' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('engineering-services/dashboard')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_ES.svg" alt="Engineering Services" />
            </span>
            <span class="side-nav-label">Eng. Services</span>
          </button>

          <!-- AI OVERVIEW (non-prd only) v-b-tooltip.hover.right :title="sidebarCollapsed ? 'AI Search' : ''"-->
          <button v-if="!prdEnv()"
                  class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'ai-overview' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('ftie/ai-overview')">
            <span class="side-nav-icon side-nav-icon--badge">
              <b-badge variant="primary" class="side-nav-new-badge">NEW</b-badge>
              <img src="../../static/image/leftbar_menu/semantic-ai-search-ftie-wh-icon-menu-bar.svg"
                   alt="AI Search" />
            </span>
            <span class="side-nav-label">AI Search</span>
          </button>

          <!-- FTIE v-b-tooltip.hover.right :title="sidebarCollapsed ? 'FTIE' : ''"-->
          <button class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'ftie' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('ftie')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_FTIE.svg" alt="FTIE" />
            </span>
            <span class="side-nav-label">FTIE</span>
          </button>

          <!-- NRE DASHBOARD v-b-tooltip.hover.right :title="sidebarCollapsed ? 'NRE' : ''"-->
          <button class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'dashboard' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('dashboard')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_NRE.svg" alt="NRE" />
            </span>
            <span class="side-nav-label">NRE</span>
          </button>

          <!-- INVENTORY v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Inventory' : ''"-->
          <button v-if="inventoryReportAccess()"
                  class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'inventory' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('inventory')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_INVENTORY.svg" alt="Inventory" />
            </span>
            <span class="side-nav-label">Inventory</span>
          </button>

          <!-- FULFILLMENT v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Fulfillment' : ''"-->
          <button v-if="fulfillmentReportAccess()"
                  class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'nre-fulfillment' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('nre-fulfillment')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_FULFILLMENT.svg" alt="Fulfillment" />
            </span>
            <span class="side-nav-label">Fulfillment</span>
          </button>

          <!-- CASE SHARING v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Case Sharing' : ''"-->
          <button class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'case-sharing' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('case-sharing')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_CASE SHARING.svg" alt="Case Sharing" />
            </span>
            <span class="side-nav-label">Case Sharing</span>
          </button>

          <!-- ADMIN v-b-tooltip.hover.right :title="sidebarCollapsed ? 'Admin' : ''"-->
          <button v-if="adminMemberSettingAccess()"
                  class="btn side-nav-btn border-radius-0 w-100"
                  v-bind:class="[_.get(btnStyle[_.findIndex(btnStyle, { 'pageName': 'admin-member-setting' })], 'style', 'btn-dark-750')]"
                  @click="buttonLink('admin-member/setting')">
            <span class="side-nav-icon">
              <img src="../../static/image/leftbar_menu/icon_MANAGE.svg" alt="Admin" />
            </span>
            <span class="side-nav-label">Admin</span>
          </button>

        </nav>

        <!-- Collapse toggle arrow at bottom of sidebar -->
        <div class="side-nav-footer">
          <button class="btn side-nav-collapse-btn w-100"
                  @click="toggleSidebar"
                  v-b-tooltip.hover.right
                  :title="sidebarCollapsed ? 'Expand' : 'Collapse'">
            <i class="fa" :class="sidebarCollapsed ? 'fa-angle-right' : 'fa-angle-left'"></i>
            <span class="side-nav-label ml-2">Collapse</span>
          </button>
        </div>

      </div>
      <!-- ===== END SIDEBAR ===== -->
      <!-- ===== MAIN CONTENT ===== -->
      <div class="main-content">
        <router-view></router-view>
      </div>

    </div>
    <!-- ===== END LAYOUT BODY ===== -->

  </div>
</template>
<script>
  import { safeUrl } from '@/helpers/vue-url';
  export default {
    name: 'MasterPage',
    data() {
      return {
        sidebarCollapsed: false,
        btnActiveStyle: 'btn-gray-750',
        btnNotActiveStyle: 'btn-dark-750',
        searchingADOPrj: false,
        searchingSFDC: false,
        sfdcReportFields: [
          //{ key: 'action', label: 'Action', thClass: 'align-middle', sortable: true },
          //{ key: 'Id', label: 'Report ID', thClass: 'align-middle', sortable: true },
          { key: 'Name', label: 'Report Name', thClass: 'align-middle', sortable: true },
          //{ key: 'action', label: 'Action', thClass: 'align-middle', sortable: true }
        ],
        azureDevOpsPrjsFields: [
          { key: 'project_id', label: 'Project ID', thClass: 'align-middle', sortable: true },
          { key: 'project_name', label: 'Project Name', thClass: 'align-middle', sortable: true },
          { key: 'action', label: 'Actions', thClass: 'align-middle', sortable: true }
        ],
        btnStyle: [
          { 'pageName': 'home', 'routerName': 'Home', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'opty', 'routerName': 'Opportunity Dashboard', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'task', 'routerName': 'Task Dashboard', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'engineering-service', 'routerName': 'Engineering Service Dashboard', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'ai-overview', 'routerName': 'FTIE AI Overview', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'ftie', 'routerName': 'FTIE Dashboard', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'dashboard', 'routerName': 'Dashboard', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'inventory', 'routerName': 'Inventory', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'nre-fulfillment', 'routerName': 'Fulfillment', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'case-sharing', 'routerName': 'Casesharing', 'style': 'btn-dark-750', 'isActive': false },
          { 'pageName': 'admin-member-setting', 'routerName': 'Member Settings', 'style': 'btn-dark-750', 'isActive': false },
          //{ 'pageName': 'optyDashboard', 'routerName': 'OptyDashboard', 'style': 'btn-dark-750', 'isActive': false },
        ], //loadash: https://lodash.com/docs/#find
        btnActiveIndex: 0,
        user_email: this.$session.get('user_id'),
        user_name: this.$session.get('user_name'),
        user_functions : this.$session.get('user_functions'),
        user_roles: this.$session.get('user_roles'),
        user_site: this.$session.get('user_site'),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        azureDevOpsPrjs: null,
        salesforceReportList: null,
        openReportIdList: ['00OQj00000Y0MhhMAF', '00OQj00000Y0JrtMAF','00OQj00000YeEDZMA3','00OQj00000YeEBxMAN',
        '00OQj000005htJM', '00O3w000005vU9o', '00O3w000005vLnB']
      }
      },
      created() {
      try {
        const saved = localStorage.getItem('sidebarCollapsed');
        if (saved !== null) this.sidebarCollapsed = saved === 'true';
      } catch (e) { }
      },

    mounted: function () {
      this.viewByMode();
      // SumoSelect's document-level click handler crashes with
      // "O.optDiv.find is not a function" when clicks from BootstrapVue's
      // dropdown reach it, because O.optDiv is not a jQuery object in that
      // context.
      // Fix: after SumoSelect has had a chance to bind, replace its
      // document 'click.sumo' handler with a guarded version that wraps
      // the original call in try/catch — so crashes are silently swallowed
      // and the dropdown toggle is never blocked.
      this.$nextTick(() => {
        if (!window.jQuery) return;
        const $ = window.jQuery;
        // Retrieve all handlers bound under the 'sumo' namespace
        const events = $._data(document, 'events') || {}; // NOSONAR
        const clickHandlers = (events.click || []).filter(h => h.namespace === 'sumo');
        clickHandlers.forEach(h => {
          const original = h.handler;
          h.handler = function (e) {
            try { original.call(this, e); } catch (err) {
              /* SumoSelect optDiv guard */
              console.warn('[SumoSelect guard]', err.message)
}
          };
        });
      });
    },
    computed: {
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      serverEnv() {
        return _.get(this.$store, 'state.env', null);
      },
      currentRouteName() {
        return this.$route.name;
      },
      envBadgeClass() {
        const mode = this.$session.get('mode');
        if (mode === 'DEV') return 'env-dev';
        if (mode === 'UAT') return 'env-uat';
        return 'env-other';
      },
      envIcon() {
        const mode = this.$session.get('mode');
        if (mode === 'DEV') return 'fa-code';
        if (mode === 'UAT') return 'fa-flask';
        return 'fa-exclamation-triangle';
      }
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      toggleSidebar() {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        // Persist state so it survives page navigation
        try {
        localStorage.setItem('sidebarCollapsed', this.sidebarCollapsed);
      } catch (e) { /* ignore */ }
    },
      createWorkItem(prj_id, prj_name){
        let self = this;
        let resultText = null;
        let witUrl = null;
        let url = self.$root.baseUrl + '/ai-service/azure-devops/wit/create/';
        let request_data = {
          project_id: prj_id,
          project_name: prj_name,
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              resultText = res['azure_devops_response'];
              witUrl = res['wit_url'];
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (witUrl !== null) {
              let redirectFullPath = witUrl;
              window.open(redirectFullPath);
            }
            console.log(self.azureDevOpsPrjs);
            // self.linkAzureDevOps();
            // self.$refs['linkAzureDevOpsModal'].show();
          })
      },
      viewByMode() {
        let self = this;
        let previousBtnIndex = _.findIndex(self.btnStyle, 'isActive');
        let routerMappingBtnIndex = _.findIndex(self.btnStyle, { 'routerName': self.currentRouteName });
        console.log("routerMappingBtnIndex:" + routerMappingBtnIndex);
        console.log("currentRouteName:" + self.currentRouteName);
        if (routerMappingBtnIndex === -1) {
          //            || 'RequestForm' 'FTIEPage'
          if ('FTIE Page' === self.currentRouteName
            || 'Request Form' === self.currentRouteName
            || 'FTIE Page Dashboard' === self.currentRouteName
            || 'Assign RD Function' === self.currentRouteName
            || 'RD Check Item' === self.currentRouteName) {
            routerMappingBtnIndex = _.findIndex(self.btnStyle, { 'routerName': 'FTIE Dashboard' });
          }
          if ('nre sign flow' === self.currentRouteName
            || 'Member Page' === self.currentRouteName
            || 'member setting add ISR' === self.currentRouteName
            || 'member setting add GRO' === self.currentRouteName) {
            routerMappingBtnIndex = _.findIndex(self.btnStyle, { 'routerName': 'Member Settings' });
          }
          if ('Task Master Page' === self.currentRouteName
            || 'Task Page' === self.currentRouteName) {
            routerMappingBtnIndex = _.findIndex(self.btnStyle, { 'routerName': 'Task Dashboard' });
          }
          if ('Opportunity Dashboard' === self.currentRouteName
            || 'Opty Page' === self.currentRouteName
            || 'Account Page' === self.currentRouteName
            || 'Account Master Page' === self.currentRouteName) {
            routerMappingBtnIndex = _.findIndex(self.btnStyle, { 'routerName': 'Opportunity Dashboard' });
          }
        }
        _.set(self.btnStyle[previousBtnIndex], 'style', self.btnNotActiveStyle);
        _.set(self.btnStyle[previousBtnIndex], 'isActive', false);
        _.set(self.btnStyle[routerMappingBtnIndex], 'style', self.btnActiveStyle);
        _.set(self.btnStyle[routerMappingBtnIndex], 'isActive', true);
      },
      outlineSalesforceReportList() {
        let self = this;
        let resultText = null;
        let url = self.$root.baseUrl + '/salesforce-py/report/list/';
        let request_data = {
          ftie_id: '',
          user_name: self.user_name,
          user_roles: self.user_roles,
          user_functions: self.user_functions,
          user_site: self.user_site,
        };
        self.searchingSFDC = true;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              resultText = res['report_result'];
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searchingSFDC = false;
            eventHub.$emit('loading', false);
            if (resultText !== null) {
              self.salesforceReportList = JSON.parse(resultText);
            }

            console.log(self.salesforceReportList);
            self.$refs['salesforceReportModal'].show();
          })
      },
      downloadSalesforceReport(reportId, reportName) {

        let self = this;
        let resultText = null;
        let purpose = 'FTIE_Salesforce_Report_' + reportName;
        let url = self.$root.baseUrl + '/salesforce-py/report/download/report-id/' + reportId;
        console.log("purpose" + purpose);
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let downloadTime = new Date();
        downloadTime = downloadTime.toISOString();
        let request_data = {
          downloadTime: downloadTime,
          //download_purpose: purpose,
          report_id: reportId,
          report_name: reportName,
          user_name: self.$session.get('user_name'),
          user_roles: self.$session.get('user_roles'),
          user_functions: self.$session.get('user_functions'),
          user_site: self.$session.get('user_site'),
        };

        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((res) => {
            if (res.status === 200) {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement('a');
              link.href = url;
              let dateTimeStr = _.replace(downloadTime, '.', '');
              dateTimeStr = _.replace(dateTimeStr, ':', '');
              dateTimeStr = _.replace(dateTimeStr, '-', '');
              let file_name = purpose + '_' + dateTimeStr + '.xlsx';
              console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description == "login") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },




      ifReportOpenDownload(reportId) {
        let self = this;
        if (_.indexOf(self.openReportIdList, reportId) > -1) {
          return true;
        }
        else {
          return false;
        }
      },

      linkAzureDevOps() {
        let self = this;
        let resultText = null;
        let url = self.$root.baseUrl + '/ai-service/azure-devops/';
        let request_data = {
          ftie_id: ''
        };
        self.searchingADOPrj = true;
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);
            if (response.status === 200) {
              resultText = res['azure_devops_response'];
            }
            else {
              // self.$message.exception('Internal Server Error!');
              resultText = null
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            self.searchingADOPrj = false;
            eventHub.$emit('loading', false);
            if (resultText !== null) {
              self.azureDevOpsPrjs = JSON.parse(resultText);
            }

            console.log(self.azureDevOpsPrjs);
            self.$refs['linkAzureDevOpsModal'].show();
          })
      },
      signout() {

        this.$session.destroy();
        this.$store.commit('clearToken');
        var url = this.$root.baseUrl + '/auth/logout/'
        this.$axios.get(url)
          .then((res) => {
            console.log('logout');
            window.location.href = this.$root.authUrl + '/Auth/SignOut' + '?redirect_uri=' + encodeURIComponent(this.$root.frontEndUrl + '/azure-login');
          })
      },
      buttonLink(page) {
        let self = this;
        let pageUrl = '/' + page;
        self.btnIsActive = page;

        let previousBtnIndex = _.findIndex(self.btnStyle, 'isActive');
        let btnIndex = _.findIndex(self.btnStyle, { 'pageName': page });

        _.set(self.btnStyle[btnIndex], 'style', self.btnActiveStyle);
        _.set(self.btnStyle[btnIndex], 'isActive', true);
        _.set(self.btnStyle[previousBtnIndex], 'style', self.btnNotActiveStyle);
        _.set(self.btnStyle[previousBtnIndex], 'isActive', false);


        if (page === 'case-sharing') {
          let redirectFullPath = 'https://getac.sharepoint.com/sites/GetacTW/RVSBG/Customization%20Sharing/Forms/AllItems.aspx';
          window.open(redirectFullPath);
          //console.log("redirectFullPath--> [case-sharing]:" + redirectFullPath);
          //this.$router.push({ redirect: window.location.href = redirectFullPath });
        }
        else {
          //will remove this once router is ready
          if (page === 'ftie') {
            pageUrl = '/ftie/ftie-dashboard';//'/' + page + '/list-view';
          }

          let redirectFullPath = self.frontEndUrlToUse + pageUrl.substring(1);
          console.log("redirectFullPath::" + redirectFullPath);
          this.$router.push({ redirect: window.location.href = redirectFullPath });
        //this.$router.push(pageUrl);
        }

      },
      toDolistAccess() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        let envQualified = ('DEV' === this.$session.get('mode') || 'UAT' === this.$session.get('mode'));
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        if ((user_site && _.indexOf(user_site, 'Getac') > -1)) {
          console.log("Access to to-do-list!");
          return true
        }
        return false;
      },
      salesforceReportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        /*
        if (this.prdEnv()) {
          return false;
        }
        */
        var user_name = this.$session.get('user_name');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        if ((user_roles && (_.indexOf(user_roles, 'Admin') > -1 ))
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA_Leader') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA_MANAGER') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
        ) {
          return true
        }
        if ((user_functions && (_.indexOf(user_functions, 'Customer Success Manager') > -1))
        ) {
          return true
        }

        return false;
      },
      optyDashboardAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        if ((user_roles && (_.indexOf(user_roles, 'Admin') > -1 || (_.indexOf(user_roles, 'ES_PM_Leader') > -1 && user_site && _.indexOf(user_site, 'Getac') > -1)))
          || (user_functions && _.indexOf(user_functions, 'Customer Success Manager') > -1)
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA_Leader') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA_MANAGER') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
        ) {
          return true
        }
        return false;
      },
      taskDashboardAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        if ((user_roles && (_.indexOf(user_roles, 'Admin') > -1 || (_.indexOf(user_roles, 'ES_PM_Leader') > -1 && user_site && _.indexOf(user_site, 'Getac') > -1)))
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA_Leader') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
          || (user_site && _.indexOf(user_site, 'GUSA') > -1 && user_roles && _.indexOf(user_roles, 'GRO_SA_MANAGER') > -1 && _.indexOf(user_roles, 'ES_PM') < 0)
        ) {
          console.log("Access to task dashboard!");
          return true
        }
        return false;
      },
      inventoryReportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1) || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
          || (user_roles && _.indexOf(user_roles, 'HQ_ES') > -1)
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1) || (user_roles && _.indexOf(user_roles, 'HQ_Sales') > -1)
          || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1) || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1)
        )
        {
          console.log("Access to inventory report!");
          return true
        }
        return false;
      },
      fulfillmentReportAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        let self = this;

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');

        if (self.prdEnv()) {
          if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
            || (user_roles && _.indexOf(user_roles, 'HQ_Sales') > -1)
            || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
            || (user_roles && _.indexOf(user_roles, 'GRO_SA_Leader') > -1)
            || (user_roles && _.indexOf(user_roles, 'GRO_Director_Header') > -1)
            || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1)
            || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1)
            //|| (user_functions && _.indexOf(user_functions, 'GRO_RSM') > -1)
            || (user_functions && _.indexOf(user_functions, 'GRO_Sales_Director') > -1)
            || (user_functions && _.indexOf(user_functions, 'GRO_Manager') > -1)
          ) {
            console.log("Access to fulfillment report!");
            return true
          }
          else {
            return false;
          }
        }
        else {
          if ('UAT' === this.$session.get('mode')) {
            return false;
          }
          if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
            || (user_roles && _.indexOf(user_roles, 'HQ_Sales') > -1)
            || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1)
            || (user_roles && _.indexOf(user_roles, 'GRO_SA_Leader') > -1)
            || (user_roles && _.indexOf(user_roles, 'GRO_Director_Header') > -1)
            || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1)
            || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1)
            || (user_functions && _.indexOf(user_functions, 'GRO_RSM') > -1)
            || (user_functions && _.indexOf(user_functions, 'GRO_Sales_Director') > -1)
            || (user_functions && _.indexOf(user_functions, 'GRO_Manager') > -1)
          ) {
            console.log("Access to fulfillment report!");
            return true
          }
          else {
            return false;
          }
        }
      },
      adminMemberSettingAccess() {
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }

        var user_name = this.$session.get('user_name');
        var options = this.$session.get('options');
        var user_email = this.$session.get('user_id');
        var user_functions = this.$session.get('user_functions');
        var user_roles = this.$session.get('user_roles');
        var user_site = this.$session.get('user_site');


        if ((user_roles && _.indexOf(user_roles, 'Admin') > -1)
          || (user_functions && _.indexOf(user_functions, 'ES PM Leader') > -1 && user_site && _.indexOf(user_site, 'Getac') > -1 )
          || (user_roles && _.indexOf(user_roles, 'ES_PM_Leader') > -1 && user_site && _.indexOf(user_site, 'Getac') > -1)
        )
        {
          /*
           *           || (user_roles && _.indexOf(user_roles, 'ES_PM') > -1)
           *                     || (user_roles && _.indexOf(user_roles, 'HQ_Sales') > -1)
          || (user_functions && _.indexOf(user_functions, 'Getac Sales Manager') > -1)
          || (user_functions && _.indexOf(user_functions, 'GRO TOP Manager') > -1) */
          console.log("Access to admin member setting!");
          return true
        }
        return false;
      }
    }
  }
</script>

<style scoped>


  /* ============================================================
   GETAC BRAND TOKENS  (reused from ai-search-page, lifted to :root scope)
   ============================================================ */
  .master {
    --getac-orange: #f77530;
    --getac-orange-light: #fff3ec;
    --getac-orange-dark: #d45e1a;
    --getac-blue: #1a3a6b;
    --getac-blue-light: #eef3fb;
    --getac-gray: #f5f6f8;
    --getac-border: #e0e3ea;
    --getac-text: #2c3142;
    --getac-text-muted: #6c757d;
    --radius-sm: 4px;
    --radius-md: 8px;
    --radius-lg: 12px;
    --shadow-sm: 0 1px 3px rgba(0,0,0,0.07);
    --shadow-md: 0 3px 12px rgba(0,0,0,0.1);
    /* Sidebar widths */
    --sidebar-w: 150px;
    --sidebar-w-collapsed: 80px;
    --topnav-h: 56px;
    font-family: 'Segoe UI', 'Microsoft JhengHei', Arial, sans-serif;
    color: var(--getac-text);
  }

  /* ============================================================
   TOP NAV
   ============================================================ */
  .top-nav {
    height: var(--topnav-h);
    z-index: 1030;
    box-shadow: 0 2px 6px rgba(0,0,0,0.25);
  }

  /* The inner navbar is offset right by sidebar width so it never overlaps the sidebar */
  .top-nav-inner {
    height: var(--topnav-h);
    padding-left: calc(1.15rem + var(--sidebar-w)) !important;
    transition: padding-left 0.25s ease;
  }

  /* When sidebar is collapsed, shift topnav content accordingly */
  .master.sidebar-collapsed .top-nav-inner {
    padding-left: calc(1.15rem + var(--sidebar-w-collapsed)) !important;
  }

  /* ── Top-nav brand block ── */
  .top-nav-brand {
    display: flex;
    align-items: center;
    gap: 0.65rem;
    flex-shrink: 0;
  }

  .top-nav-logo {
    height: 1.5rem;
    flex-shrink: 0;
  }

  .top-nav-title-block {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }

  .top-nav-system-name {
    font-size: 0.92rem;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.02em;
    white-space: nowrap;
  }

  .top-nav-version {
    font-size: 0.68rem;
    color: rgba(255, 255, 255, 0.55);
    white-space: nowrap;
  }

  /* ── Environment badge ── */
  .top-nav-env-badge {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin-left: 0.9rem;
    padding: 0.22rem 0.75rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    white-space: nowrap;
    flex-shrink: 0;
    border: 1.5px solid transparent;
  }

    .top-nav-env-badge .env-label {
      font-weight: 800;
      text-transform: uppercase;
    }

    .top-nav-env-badge .env-sublabel {
      font-weight: 400;
      opacity: 0.85;
      font-size: 0.68rem;
      max-width: 180px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

  /* DEV — blue */
  .env-dev {
    background: rgba(30, 100, 220, 0.18);
    border-color: #4a90d9;
    color: #7ec8ff;
  }

  /* UAT — amber/yellow */
  .env-uat {
    background: rgba(240, 170, 30, 0.18);
    border-color: #e6a817;
    color: #ffd166;
  }

  /* other non-prd modes */
  .env-other {
    background: rgba(220, 60, 60, 0.18);
    border-color: #e05555;
    color: #ff9a9a;
  }

  /* ── Legacy (keep for any existing references) ── */
  .system-name {
    font-size: 0.82rem;
    font-weight: 600;
    letter-spacing: 0.01em;
  }

  .user-name {
    font-size: 0.82rem;
  }

  /* ============================================================
   USER DROPDOWN  — RWD fixes
   ============================================================ */

  /* Right-side user nav: no right margin on small screens */
  .top-nav-user-nav {
    margin-right: 0.75rem;
    flex-shrink: 0;
  }

  /* Always right-align the dropdown menu so it never overflows
     the right edge of the viewport */
  ::v-deep .b-nav-item-dropdown .dropdown-menu {
    right: 0 !important;
    left: auto !important;
  }

  /* Tighten the toggle button so it fits inside the 56px topnav */
  ::v-deep .b-nav-item-dropdown > .nav-link {
    display: flex;
    align-items: center;
    padding-top: 0;
    padding-bottom: 0;
  }

  /* Scale down the oversized user icon to sit inside topnav */
  ::v-deep .b-nav-item-dropdown .nav-link img[alt="User Icon"] {
    height: 2.2rem !important;
  }

  /* Give each dropdown item comfortable tap targets on touch devices */
  ::v-deep .b-nav-item-dropdown .dropdown-item {
    padding: 0.55rem 1.25rem;
    font-size: 0.88rem;
    white-space: nowrap;
  }

  /* -----------------------------------new */

  /* ============================================================
   LAYOUT BODY  (sidebar + main side by side)
   ============================================================ */
  .layout-body {
    display: flex;
    padding-top: var(--topnav-h);
    min-height: 100vh;
  }

  /* ============================================================
   SIDEBAR
   ============================================================ */
  .side-nav {
    width: var(--sidebar-w);
    min-height: calc(100vh - var(--topnav-h));
    position: fixed;
    /*
        top: calc(-4.45rem + var(--topnav-h));
        left: -72px;
        z-index: 1020;
    */
    top: calc(-8.45rem + var(--topnav-h));
    left: -69.75px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: width 0.25s ease;
    z-index: 1031; /* above top-nav (1030) so hamburger overlaps the header */
    box-shadow: 2px 0 8px rgba(0,0,0,0.18);
  }

    /* Collapsed state */
    .side-nav.side-nav-collapsed {
      width: var(--sidebar-w-collapsed);
    }

  /* Nav items scrollable area */
  .side-nav-items {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding-top: 0.25rem;
  }

  /* Hamburger toggle button — overlaps the top nav header row */
  .side-nav-toggle-btn {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0 0.45rem;
    height: var(--topnav-h); /* matches topnav exactly */
    border-radius: 0 !important;
    background-color: var(--getac-orange) !important;
    border: none;
    /* border-left: 3px solid var(--getac-orange-dark); */
    border-bottom: 2px solid var(--getac-orange-dark); /* separator from menu items below */
    white-space: nowrap;
    overflow: hidden;
    flex-shrink: 0;
    transition: background-color 0.15s;
    z-index: 1032; /* above everything */
  }

    .side-nav-toggle-btn:hover {
      background-color: var(--getac-orange-dark) !important;
    }

    .side-nav-toggle-btn .side-nav-label {
      color: rgba(255,255,255,0.9);
      font-size: 0.8rem;
      font-weight: 700;
      letter-spacing: 0.03em;
    }

  /* Each nav button */
  .side-nav-btn {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.5rem 0.25rem;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 0 !important;
    transition: background 0.15s, border-left 0.15s;
    border-left: 3px solid transparent;
  }

    .side-nav-btn:hover {
      border-left-color: var(--getac-orange);
      background-color: rgba(247, 117, 48, 0.12) !important;
    }

    /* Active state - reuse btn-primary colours */
    .side-nav-btn.btn-primary {
      border-left-color: var(--getac-orange);
    }

  /* Icon wrapper */
  .side-nav-icon {
    flex-shrink: 0;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

    .side-nav-icon img {
      width: 45px;
      height: 45px;
      object-fit: contain;
    }

  /* Label - fades out when collapsed */
  .side-nav-label {
    font-size: 0.8rem;
    font-weight: 600;
    color: rgba(255,255,255,0.85);
    opacity: 1;
    white-space: nowrap;
    transition: opacity 0.2s ease, width 0.2s ease;
    overflow: hidden;
  }

  .side-nav-collapsed .side-nav-label {
    opacity: 0;
    width: 0;
    pointer-events: none;
  }

  /* NEW badge on AI Search */
  .side-nav-icon--badge {
    position: relative;
  }

  .side-nav-new-badge {
    position: absolute;
    top: -6px;
    right: -8px;
    font-size: 0.5rem;
    padding: 1px 3px;
    line-height: 1.2;
    z-index: 1;
  }

  /* Bottom collapse toggle */
  .side-nav-footer {
    border-top: 1px solid rgba(255,255,255,0.08);
    padding: 0.25rem 0;
  }

  .side-nav-collapse-btn {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0.6rem 0.85rem;
    color: rgba(255,255,255,0.5);
    background: transparent;
    border: none;
    border-radius: 0;
    font-size: 0.8rem;
    white-space: nowrap;
    overflow: hidden;
    transition: color 0.15s, background 0.15s;
  }

    .side-nav-collapse-btn:hover {
      color: var(--getac-orange);
      background: rgba(247,117,48,0.1);
    }

    .side-nav-collapse-btn i {
      flex-shrink: 0;
      font-size: 1rem;
      width: 28px;
      text-align: center;
    }

  /* ============================================================
   MAIN CONTENT
   ============================================================ */
  .main-content {
    flex: 1;
    margin-left: var(--sidebar-w);
    padding: 1.25rem 1.15rem;
    transition: margin-left 0.25s ease;
    min-width: 0; /* prevent flex overflow */
  }

  .master.sidebar-collapsed .main-content {
    margin-left: var(--sidebar-w-collapsed);
  }




  /* ============================================================
   ALL ORIGINAL CSS KEPT INTACT BELOW
   ============================================================ */
  .page-header {
    padding: 0.75rem 0 0.5rem;
    border-bottom: 2px solid var(--getac-border);
    margin-bottom: 0.25rem;
  }

  .caption-label {
    font-size: 1.05rem;
    font-weight: 700;
    color: var(--getac-text);
    letter-spacing: 0.01em;
  }

  .header-subtitle {
    font-size: 0.75rem;
    color: var(--getac-text-muted);
    margin-top: 1px;
  }

  .header-icon-wrap {
    width: 38px;
    height: 38px;
    background: var(--getac-orange-light);
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--getac-orange);
    font-size: 1.1rem;
  }


  .mode-badge {
    font-size: 0.72rem;
    padding: 0.25em 0.5em;
  }


  .mode-tab {
    flex: 1;
    background: none;
    border: none;
    border-right: 1px solid var(--getac-border);
    padding: 0.6rem 1rem;
    cursor: pointer;
    font-size: 0.82rem;
    font-weight: 600;
    color: var(--getac-text-muted);
    text-align: left;
    transition: all 0.15s;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1px;
  }

    .mode-tab:last-child {
      border-right: none;
    }

    .mode-tab .tab-desc {
      font-size: 0.68rem;
      font-weight: 400;
      color: #aaa;
    }

    .mode-tab.active {
      background: #fff;
      color: var(--getac-orange);
      border-bottom: 2px solid var(--getac-orange);
      margin-bottom: -1px;
    }

      .mode-tab.active .tab-desc {
        color: #b08060;
      }

    .mode-tab:hover:not(.active) {
      background: #ececec;
      color: var(--getac-text);
    }


  .sub-label {
    font-size: 0.78rem;
    font-weight: 600;
    color: #555;
    margin-bottom: 0.25rem;
    display: block;
  }

  .filter-group-label {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--getac-blue);
    border-bottom: 1px solid var(--getac-border);
    padding-bottom: 0.3rem;
  }

  .gtc-select, .gtc-input {
    font-size: 0.82rem;
    height: calc(1.5em + 0.5rem + 2px);
    border-color: var(--getac-border);
  }

  .condition-filters {
    background: var(--getac-gray);
    border-radius: var(--radius-md);
    padding: 0.75rem 1rem;
    border: 1px solid var(--getac-border);
  }

  .semantic-input-area {
    background: var(--getac-blue-light);
    border-radius: var(--radius-md);
    padding: 0.75rem 1rem;
    border: 1px solid #c8d8f0;
  }

  .ai-hint-badge {
    font-size: 0.68rem;
    background: var(--getac-orange-light);
    color: var(--getac-orange-dark);
    border: 1px solid #f7c4a0;
    padding: 0.15em 0.5em;
    border-radius: 20px;
    font-weight: 600;
  }

  .semantic-textarea-wrap {
    border: 1px solid #c8d8f0;
    border-radius: var(--radius-sm);
    background: #fff;
    overflow: hidden;
  }

  .semantic-textarea {
    border: none;
    resize: vertical;
    font-size: 0.85rem;
    background: transparent;
  }

    .semantic-textarea:focus {
      box-shadow: none;
      border: none;
    }

  .textarea-footer {
    background: #f8f9fc;
    border-top: 1px solid var(--getac-border);
    font-size: 0.72rem;
  }

  .char-count {
    color: var(--getac-text-muted);
  }

  .btn-search-main {
    padding: 0.35rem 1.2rem;
    font-weight: 700;
    font-size: 0.9rem;
    border-radius: var(--radius-sm);
    background-color: var(--getac-orange);
    border-color: var(--getac-orange);
  }

    .btn-search-main:hover {
      background-color: var(--getac-orange-dark);
      border-color: var(--getac-orange-dark);
    }

  .ai-overview-card {
    background: linear-gradient(135deg, #fff8f3 0%, #fef9ff 100%);
    border: 1px solid #f5c8a8;
    border-radius: var(--radius-lg);
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(247,117,48,0.08);
  }

  .ai-overview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.7rem 1rem;
    background: linear-gradient(90deg, #fff3e8, #fdf4fc);
    border-bottom: 1px solid #f0c8a0;
  }

  .ai-spark-icon {
    width: 32px;
    height: 32px;
    background: rgba(247,117,48,0.12);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
  }

  .ai-overview-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--getac-text);
  }

  .ai-overview-sub {
    font-size: 0.7rem;
    color: var(--getac-text-muted);
  }

  .source-badge {
    font-size: 0.7rem;
    border: 1px solid var(--getac-border);
    color: #555;
  }

  .ai-overview-body {
    padding: 0.85rem 1.1rem;
  }

  .overview-block {
    background: #fff;
    border: 1px solid #f0e4d8;
    border-radius: var(--radius-sm);
    padding: 0.6rem 0.85rem;
  }

  .overview-block-label {
    font-size: 0.72rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: var(--getac-orange);
    margin-bottom: 0.4rem;
  }

  .overview-content {
    font-size: 0.85rem;
    color: #444;
    line-height: 1.65;
  }

  .ai-overview-sources {
    padding: 0.5rem 1rem;
    background: rgba(247,117,48,0.04);
    border-top: 1px solid #f0c8a0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.35rem;
  }

  .source-pill-label {
    font-size: 0.7rem;
    font-weight: 700;
    color: #888;
    text-transform: uppercase;
    margin-right: 0.25rem;
  }

  .source-pill {
    font-size: 0.72rem;
    background: #fff;
    border: 1px solid #f0c8a0;
    border-radius: 20px;
    padding: 0.15em 0.65em;
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    color: #555;
  }

    .source-pill a {
      color: var(--getac-blue);
      text-decoration: none;
      font-weight: 600;
    }

      .source-pill a:hover {
        text-decoration: underline;
      }

  .pill-score {
    background: var(--getac-orange-light);
    color: var(--getac-orange);
    border-radius: 10px;
    padding: 0 0.3em;
    font-size: 0.65rem;
    font-weight: 700;
  }

  .source-pill-more {
    background: var(--getac-gray);
    border-color: var(--getac-border);
    color: var(--getac-text-muted);
  }

  .tool-icon-wrap {
    width: 34px;
    height: 34px;
    border-radius: var(--radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    flex-shrink: 0;
  }

  .tool-content {
    flex: 1;
    min-width: 0;
  }

  .tool-name {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--getac-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tool-desc {
    font-size: 0.68rem;
    color: var(--getac-text-muted);
    line-height: 1.3;
    margin-top: 1px;
  }

  .tool-output-area {
    border: 1px solid var(--getac-border);
    border-radius: var(--radius-md);
    background: #fafbfd;
    padding: 0.85rem 1rem;
  }

  .tool-output-header {
    padding-bottom: 0.5rem;
    border-bottom: 1px solid var(--getac-border);
    margin-bottom: 0.5rem;
  }

  .tool-textarea {
    font-size: 0.83rem;
    border-color: var(--getac-border);
    background: #fff;
  }

  .tool-empty-state {
    text-align: center;
    padding: 2rem;
    color: #bbb;
    font-size: 0.82rem;
    cursor: pointer;
    border: 2px dashed var(--getac-border);
    border-radius: var(--radius-md);
    transition: all 0.15s;
  }

    .tool-empty-state:hover {
      border-color: var(--getac-orange);
      color: var(--getac-orange);
      background: var(--getac-orange-light);
    }

  .nre-insight-display, .tco-display, .parts-display {
    font-size: 0.85rem;
    line-height: 1.65;
    color: #444;
  }

  .results-header {
    padding: 0.25rem 0;
  }

  ::v-deep .thead-getac th {
    background-color: var(--getac-gray) !important;
    color: var(--getac-text) !important;
    font-size: 0.78rem;
    font-weight: 700;
    border-bottom: 2px solid var(--getac-border);
    white-space: nowrap;
  }

  ::v-deep .b-table tbody tr:hover td {
    background-color: var(--getac-orange-light) !important;
  }

  .score-cell {
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

  .score-bar-wrap {
    flex: 1;
    height: 6px;
    background: #e8e8e8;
    border-radius: 3px;
    overflow: hidden;
  }

  .score-bar {
    height: 100%;
    background: linear-gradient(90deg, var(--getac-orange), var(--getac-orange-dark));
    border-radius: 3px;
    transition: width 0.3s;
  }

  .score-label {
    font-size: 0.72rem;
    font-weight: 700;
    color: var(--getac-orange);
    white-space: nowrap;
  }

  .status-badge {
    font-size: 0.7rem;
  }

  .sub-ticket-detail {
    background: var(--getac-gray);
    border-left: 3px solid var(--getac-orange);
    padding: 0.5rem 1rem;
    font-size: 0.8rem;
  }

  .link {
    color: var(--getac-blue);
    text-decoration: none;
    font-weight: 600;
  }

    .link:hover {
      color: var(--getac-orange);
      text-decoration: underline;
    }

  .typing-indicator {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
  }

    .typing-indicator span {
      width: 7px;
      height: 7px;
      background: var(--getac-orange);
      border-radius: 50%;
      display: inline-block;
      margin-right: 3px;
      animation: typing-bounce 1.2s infinite;
    }

      .typing-indicator span:nth-child(2) {
        animation-delay: 0.2s;
      }

      .typing-indicator span:nth-child(3) {
        animation-delay: 0.4s;
      }

  @keyframes typing-bounce {
    0%, 80%, 100% {
      transform: scale(0.7);
      opacity: 0.5;
    }

    40% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .fade-slide-enter-active, .fade-slide-leave-active {
    transition: opacity 0.25s, transform 0.25s;
  }

  .fade-slide-enter, .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }

  /* ============================================================
   RWD
   ============================================================ */
  /* Tablet: auto-collapse sidebar */
  @media (max-width: 992px) {
    .master {
      --sidebar-w: 180px;
    }
    /* Tablet: hide route name in env badge to save space */
    .top-nav-env-badge .env-sublabel {
      display: none;
    }
  }

  /* Mobile: sidebar collapses fully by default; overlay mode */
  @media (max-width: 768px) {
    .master {
      --sidebar-w: var(--sidebar-w-collapsed); /* collapsed by default on mobile */
    }

      /* On mobile, expanded sidebar is an overlay */
      .master:not(.sidebar-collapsed) .side-nav {
        width: 200px;
        box-shadow: 4px 0 16px rgba(0,0,0,0.35);
        /* z-index: 1025;*/
        z-index: 1031;
      }

    /* Main content always full width on mobile */
    .main-content {
      margin-left: var(--sidebar-w-collapsed) !important;
    }

    .search-mode-tabs {
      flex-direction: column;
    }

    .mode-tab {
      border-right: none;
      border-bottom: 1px solid var(--getac-border);
    }

    /* Mobile top-nav: tighten right-side padding */
    .top-nav-inner {
      padding-right: 0.25rem !important;
    }

    /* Shrink right margin of user nav section */
    .top-nav-user-nav {
      margin-right: 0 !important;
    }

    /* Hide version text on mobile */
    .top-nav-version {
      display: none;
    }

    /* Env badge: keep colored border, hide text label to save space */
    .top-nav-env-badge {
      padding: 0.2rem 0.5rem;
      gap: 0.25rem;
    }

      .top-nav-env-badge .env-label {
        display: none;
      }

    /* Hide user name text on mobile; keep only the user icon */
    .user-name {
      display: none !important;
    }

    /* Mobile dropdown: stretch to a comfortable width,
       keep it pinned to the right so it never clips */
    ::v-deep .b-nav-item-dropdown .dropdown-menu {
      min-width: 200px;
      right: 0 !important;
      left: auto !important;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/MasterPage.vue